var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.CardWrapper,{staticClass:"p-0",attrs:{"title":_setup.title,"subtitle":_setup.subtitle,"notice":_setup.notice}},[_c('div',{staticClass:"col-12 p-md-3 px-4"},[_c(_setup.AnalyticCards)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }